import { useState, useCallback } from 'react';
import { useLoginMutation, GetMyAccountDocument } from 'graphql/types';
import { AUTH_TOKEN } from 'constant';
import LocalStore from 'helpers/localStore';
import { LoginReq } from 'services/auth';
import { message } from 'antd';

function useLogin() {
  const [userLogin, { loading: loginLoading, client }] = useLoginMutation({});
  const [submitting, setSubmitting] = useState(false);

  const login = useCallback(
    async (data: LoginReq, onSuccess: () => void = () => { }) => {
      try {
        setSubmitting(true);
        const result = await userLogin({
          variables: { input: data },
        });
        const token = result?.data?.login?.jwt;
        if (!token) {
          throw new Error('Authenication Failed!');
        }
        LocalStore.set(AUTH_TOKEN, token);

        if ('serviceWorker' in navigator) {
          const userInfo = await client.query({
            query: GetMyAccountDocument,
            fetchPolicy: 'network-only',
          });
          if (navigator.serviceWorker.controller) {
            navigator.serviceWorker.controller.postMessage({
              type: "LOCAL_DATA",
              userId: userInfo.data?.myAccount?.data?.id || ''
            });
          }
        }
        // LocalStore.set(LOGIN_USER_ID, userInfo.data?.myAccount?.data?.id || '');
        onSuccess();
      } catch (err) {
        LocalStore.remove(AUTH_TOKEN);
        if (err instanceof Error) {
          message.error(err.message);
        }
      } finally {
        setSubmitting(false);
      }
    },
    [userLogin, client],
  );
  // Expose combined loading (mutation or follow-up query)
  const loading = loginLoading || submitting;

  return [loading, login] as const;
}

export default useLogin;
